import { render } from "./HomeReturn.vue?vue&type=template&id=1af2e8c6"
import script from "./HomeReturn.vue?vue&type=script&lang=js"
export * from "./HomeReturn.vue?vue&type=script&lang=js"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__